import { useEffect, useState } from 'react';
import {
  HiringHistoryDrawerResponse,
  getHiringHistoryDetail,
  peekHiringHistoryDetail,
} from 'services/actions/ai_management_hiring_history';

export function useHiringHistoryDetail(
  biddingId: number | null,
  historicBiddingId: number | null,
  item: string | null,
) {
  const peek = () =>
    biddingId && historicBiddingId && item
      ? peekHiringHistoryDetail(biddingId, historicBiddingId, item)
      : undefined;
  const [detail, setDetail] = useState<HiringHistoryDrawerResponse | null>(
    () => peek()?.data ?? null,
  );
  const [loading, setLoading] = useState(() => !peek());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!biddingId || !historicBiddingId || !item) {
      setLoading(false);
      setError(true);
      return undefined;
    }

    const hit = peek();
    if (hit) {
      setDetail(hit.data);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError(false);
    setDetail(null);

    getHiringHistoryDetail(biddingId, historicBiddingId, item)
      .then(({ data }) => {
        if (!active) return;
        setDetail(data);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [biddingId, historicBiddingId, item]);

  return { detail, loading, error };
}
